export { default } from './part-accordion';
